module.exports = __webpack_public_path__ + "static/media/mu.01f12e8f.svg";